// メンター登録・編集フォームで使用する選択肢データ

// 正規リスト外の出身大学（OG登録・編集のみで使用）
export const OTHER_UNIVERSITY_ID = 'other';
export const OTHER_UNIVERSITY_LABEL = 'その他';
export const OTHER_UNIVERSITY_NAME_MAX_LENGTH = 100;

// 卒業年の選択肢を生成
export const generateGraduationYears = () => {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let year = currentYear + 1; year >= 2000; year--) {
    years.push(year);
  }
  return years;
};

// 業界カテゴリと詳細業界の選択肢
export const industryCategories = {
  "IT・情報通信": [
    "ソフトウェア開発",
    "Webサービス・アプリ開発",
    "インフラ・ネットワーク",
    "AI・機械学習",
    "データサイエンス・分析",
    "情報セキュリティ",
    "ゲーム開発",
    "システム運用・保守",
    "ITコンサルティング",
    "その他IT関連"
  ],
  "金融・保険": [
    "銀行（メガバンク）",
    "銀行（地方銀行・信用金庫）",
    "証券・投資銀行",
    "保険（生命保険）",
    "保険（損害保険）",
    "フィンテック",
    "資産運用・投資顧問",
    "クレジット・リース",
    "その他金融関連"
  ],
  "メーカー・製造業": [
    "自動車・輸送機器",
    "電子・電気機器",
    "機械・精密機器",
    "化学・素材",
    "食品・飲料",
    "医薬品・バイオ",
    "繊維・アパレル",
    "鉄鋼・金属",
    "住宅・建材",
    "その他製造業"
  ],
  "商社・流通": [
    "総合商社",
    "専門商社",
    "百貨店・デパート",
    "スーパー・量販店",
    "コンビニエンスストア",
    "専門小売店",
    "EC・通販",
    "卸売業",
    "その他流通関連"
  ],
  "コンサルティング": [
    "戦略コンサルティング",
    "ITコンサルティング",
    "業務コンサルティング",
    "人事・組織コンサルティング",
    "財務・会計コンサルティング",
    "その他コンサルティング"
  ],
  "広告・マーケティング": [
    "広告代理店",
    "デジタルマーケティング",
    "PR・広報",
    "イベント・展示会",
    "市場調査・リサーチ",
    "その他広告・マーケティング関連"
  ],
  "メディア・エンターテイメント": [
    "テレビ・ラジオ",
    "新聞・雑誌・出版",
    "映画・映像制作",
    "音楽・レコード",
    "ゲーム・アニメ",
    "その他メディア・エンタメ関連"
  ],
  "公務員・教育": [
    "国家公務員",
    "地方公務員",
    "教員・講師",
    "研究機関",
    "その他公務員・教育関連"
  ],
  "医療・福祉": [
    "病院・クリニック",
    "製薬・医療機器",
    "介護・福祉",
    "その他医療・福祉関連"
  ],
  "その他": [
    "建設・不動産",
    "運輸・物流",
    "エネルギー・インフラ",
    "農林水産業",
    "その他"
  ]
};

// 既存の業界データから分解して適切なカテゴリとサブカテゴリを見つける
export const findIndustryCategory = (industryData) => {
  let foundCategory = '';
  let foundSubcategory = '';
  
  // "カテゴリ - サブカテゴリ" の形式かチェック
  if (industryData && industryData.includes(' - ')) {
    const parts = industryData.split(' - ');
    if (parts.length === 2) {
      foundCategory = parts[0];
      foundSubcategory = parts[1];
      return { foundCategory, foundSubcategory };
    }
  }
  
  // 従来の形式（サブカテゴリのみ）の場合
  for (const [category, subcategories] of Object.entries(industryCategories)) {
    if (subcategories.includes(industryData)) {
      foundCategory = category;
      foundSubcategory = industryData;
      break;
    }
  }
  
  return { foundCategory, foundSubcategory };
};